import { request } from "@frontend/lib/http";

import type { EmployeeOption } from "../types";

type RequestOptions = {
  signal?: AbortSignal;
};

export type EmployeeApi = {
  /**
   * Archived employees are left out. A record still naming one shows them
   * through the field's fallback rather than offering them again.
   */
  fetchEmployees(options?: RequestOptions): Promise<EmployeeOption[]>;
};

export const employeeApi: EmployeeApi = {
  fetchEmployees(options) {
    return request({
      route: "api_employees_list",
      query: { archived: false },
      ...options,
    });
  },
};
